/** 空字符串视为合法（可保存，预览用缺省图） */
export const isValidYouTubeUrlInput = (raw: string): boolean => {
  const trimmed = raw.trim()

  if (trimmed === "") {
    return true
  }
  let url: URL

  try {
    url = new URL(trimmed.includes("://") ? trimmed : `https://${trimmed}`)
  } catch {
    return false
  }
  const host = url.hostname.toLowerCase()

  return host === "youtu.be"
    || host === "www.youtube.com"
    || host === "youtube.com"
    || host.endsWith(".youtube.com")
}

const YOUTUBE_VIDEO_ID_RE = /^[a-zA-Z0-9_-]{11}$/

/**
 * 从常见 YouTube 页面地址解析 11 位视频 id；无法解析时返回 null。
 */
export const parseYouTubeVideoId = (raw: string): string | null => {
  const trimmed = raw.trim()
  if (!trimmed) {
    return null
  }
  let url: URL

  try {
    url = new URL(trimmed.includes("://") ? trimmed : `https://${trimmed}`)
  } catch {
    return null
  }
  const host = url.hostname.toLowerCase()
  const pathname = url.pathname

  if (host === "youtu.be") {
    const id = pathname.split("/").filter(Boolean)[0]
    return id && YOUTUBE_VIDEO_ID_RE.test(id) ? id : null
  }

  const isYouTubeHost = host === "www.youtube.com"
    || host === "youtube.com"
    || host === "m.youtube.com"
    || host.endsWith(".youtube.com")

  if (!isYouTubeHost) {
    return null
  }

  const fromQuery = url.searchParams.get("v")
  if (fromQuery && YOUTUBE_VIDEO_ID_RE.test(fromQuery)) {
    return fromQuery
  }

  const fromEmbed = pathname.match(/^\/embed\/([a-zA-Z0-9_-]{11})(?:\/|$)/)
  if (fromEmbed) {
    return fromEmbed[1]
  }

  const fromShorts = pathname.match(/^\/shorts\/([a-zA-Z0-9_-]{11})(?:\/|$)/)
  if (fromShorts) {
    return fromShorts[1]
  }

  const fromLive = pathname.match(/^\/live\/([a-zA-Z0-9_-]{11})(?:\/|$)/)
  if (fromLive) {
    return fromLive[1]
  }

  return null
}
